import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { AvailableOrInstalledConnection, SupportedAccount } from 'app/connections/types'

import { CodeTag } from 'components'

import connectStyles from '../../../Connect.module.scss'
import { ConnectionStepper } from '../../components/ConnectionStepper/ConnectionStepper'
import styles from './AccountsAndIdsStep.module.scss'

interface SettingsStepProps extends PropsWithChildren {
  accounts: SupportedAccount[]
  connection: AvailableOrInstalledConnection
}

const getAccountDetail = (account: SupportedAccount) => {
  if ('businessName' in account) return account.businessName
  if ('partnerId' in account) return account.partnerId
  if ('managerId' in account) return account.managerId
  return undefined
}

export const AccountsAndIdsStep = ({ accounts, children, connection }: SettingsStepProps) => {
  const { t } = useTranslation('connections')
  const connectionName = t(`available.${connection.name}.displayName`)

  return (
    <>
      <ConnectionStepper activeStep={4} />
      <section className={connectStyles.accountsAndIdsCard}>
        <header>
          <h2>{t('setup.settings.accounts.title')}</h2>
          <p>{t('setup.settings.accounts.description')}</p>
        </header>
        <div className={styles.settingsAccounts}>
          {accounts.map((account) => {
            const detail = getAccountDetail(account)
            return (
              <div className={styles.settingsAccount} key={account.id}>
                <CodeTag>{account.id}</CodeTag>
                <strong>{account.name}</strong>
                {detail && <span>{detail}</span>}
              </div>
            )
          })}
        </div>
      </section>
      <section className={connectStyles.accountsAndIdsCard}>
        <header>
          <h2>{t('setup.settings.ids.title', { connection: connectionName })}</h2>
          <p>{t('setup.settings.ids.description')}</p>
        </header>
        <div className={connectStyles.settingsFields}>{children}</div>
      </section>
    </>
  )
}
